import { render, staticRenderFns } from "./LoudspeakerBox.vue?vue&type=template&id=43a58eed&scoped=true"
import script from "./LoudspeakerBox.vue?vue&type=script&lang=js"
export * from "./LoudspeakerBox.vue?vue&type=script&lang=js"
import style0 from "./LoudspeakerBox.vue?vue&type=style&index=0&id=43a58eed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a58eed",
  null
  
)

export default component.exports